import { Section, SectionType } from './section';

export interface ButtonSection extends Section {
    type: SectionType.button;
    link: string;
    text: string;
    html?: string; // TODO: remove this if it's not used
    msoHtml?: string;
}

export function isButtonSection(section?: Section): section is ButtonSection {
    return !!section && section.type === SectionType.button;
}
